import { useState } from 'react';

import { Overlay } from '@american-autonomy/ag-ui';

import ResourceAddButton from 'components/buttons/ResourceAddButton';

import { useFloatingResourceAddContext } from 'hooks/useFloatingResourceAddContext';
import useFloatingResourceAddRoute from 'hooks/useFloatingResourceAddRoute';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FloatingResourceAddButton: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { visible } = useFloatingResourceAddContext();
    const { defaultAssetType, defaultResource } = useFloatingResourceAddRoute();
    const [isFloatingResourceMenuOpen, setIsFloatingResourceMenuOpen] = useState(false);

    const openClass = isFloatingResourceMenuOpen ? styles.open : '';

    if (!visible) {
        return null;
    }

    return (
        <Overlay className={`${openClass} ${styles.floatingResourceAddButton}`} testId={testId}>
            <ResourceAddButton
                defaultAssetType={defaultAssetType}
                defaultResource={defaultResource}
                onOpenChange={setIsFloatingResourceMenuOpen}
            />
        </Overlay>
    );
};

export default FloatingResourceAddButton;
